import script from "./features.vue?vue&type=script&setup=true&lang=js"
export * from "./features.vue?vue&type=script&setup=true&lang=js"

import "./features.vue?vue&type=style&index=0&id=01fdd624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01fdd624"]])

export default __exports__